<template>
  <div>
    <div class="mui-card">
      <div class="mui-card-content">
        <div class="mui-card-content-inner">
          组员人数
          <span class="mui-card-content-inner-right">18人</span>
        </div>
      </div>
    </div>
    <div class="mui-card">
      <ul class="mui-table-view">
        <li class="mui-table-view-cell mui-media">
          <router-link class="mui-navigate-right"  to='/user/contributionDetail'>
            <img class="mui-media-object mui-pull-left" src="/static/images/avatar.png">
            <div class="mui-media-body">
              <div class="mui-media-body-left">
                用户1
                <p class='mui-ellipsis'>累计贡献<span style="color: red;font-size: 16px">3</span>处设施</p>
              </div>
              <div class="mui-media-body-right">
                <span>积分：3</span>
              </div>
            </div>
          </router-link>
        </li>
        <li class="mui-table-view-cell mui-media">
          <router-link class="mui-navigate-right" to='/user/contributionDetail'>
            <img class="mui-media-object mui-pull-left" src="/static/images/avatar.png">
            <div class="mui-media-body">
              <div class="mui-media-body-left">
                用户2
                <p class='mui-ellipsis'>累计贡献<span style="color: red;font-size: 16px">4</span>处设施</p>
              </div>
              <div class="mui-media-body-right">
                <span>积分：3</span>
              </div>
            </div>
          </router-link>
        </li>
        <li class="mui-table-view-cell mui-media">
          <router-link class="mui-navigate-right" to='/user/contributionDetail'>
            <img class="mui-media-object mui-pull-left" src="/static/images/avatar.png">
            <div class="mui-media-body">
              <div class="mui-media-body-left">
                用户3
                <p class='mui-ellipsis'>累计贡献<span style="color: red;font-size: 16px">5</span>处设施</p>
              </div>
              <div class="mui-media-body-right">
                <span>积分：3</span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'group'
}
</script>

<style scoped lang="scss">
.mint-swipe{
  height:178.5px;
  .mint-swipe-item{
    img{
      width: 100%;
    }
  }
}

.mui-card-content-inner{
  font-size: 16px;
  .mui-card-content-inner-right{
    width: 70%;
    text-align: right;
    display: inline-block;
    font-size: 18px;
    color: #2ac845;
  }
}

.mui-table-view{
  .mui-table-view-cell{
    .mui-media-body{
      width: 70%;
      .mui-media-body-left{
        width: 68%;
        float: left;
      }
      .mui-media-body-right{
        width: 32%;
        font-size: 18px;
        text-align: center;
        display: inline-block;
        margin-top: 14px;
        color: #2ac845;
      }
    }
  }
}

.mui-navigate-right:after, .mui-push-right:after {
  right: 30px;
  content: '\E583';
}
</style>



// WEBPACK FOOTER //
// src/components/user/group.vue